import styled from "@emotion/styled";
var Svg = /*#__PURE__*/ styled("svg", {
    target: "eon3n9f0"
})("vertical-align:bottom;");
export { Svg };
